/* eslint-disable react/jsx-props-no-spreading, react/require-default-props */
import React, { ChangeEvent, useState } from 'react';
import { TextInput } from '@sede-enterprise/shell-ds-react-framework';
import { ITextInputProps } from '@sede-enterprise/shell-ds-react-framework/build/esm/components/TextInput/TextInput.types';
import { Controller, UseControllerProps } from 'react-hook-form';
import ErrorMessage from '../ErrorMessage';
import { IMemoisedComponentProp } from '../../types/Common.type';

interface ITextInput extends ITextInputProps {
  'data-testid'?: string;
}

interface ITextInputControl extends IMemoisedComponentProp {
  controllerProps: UseControllerProps;
  label: string;
  thousandSeparator?: boolean;
  handleOnChange?: (event: ChangeEvent<HTMLInputElement>) => void | boolean;
  inputProps?: ITextInput;
}

const FormControlTextInput: React.FC<ITextInputControl> = ({
  methods,
  controllerProps,
  label,
  thousandSeparator = false,
  handleOnChange,
  inputProps,
}) => {
  const {
    formState: { errors },
    control,
  } = methods;
  const { name } = controllerProps;
  const fieldError =
    typeof name === 'string'
      ? name.split('.').reduce((acc, key) => acc?.[key], errors as any)
      : undefined;
  const errorMessage = fieldError?.message;
  const [inputType, setInputType] = useState<string>(
    thousandSeparator ? 'text' : (inputProps?.type ?? 'text'),
  );

  return (
    <>
      <Controller
        control={control}
        {...controllerProps}
        render={({ field: { onChange, value } }) => (
          <div>
            <span>{label}</span>
            <TextInput
              placeholder={label}
              onChange={(event) => {
                if (handleOnChange && handleOnChange(event) === false) {
                  return;
                }
                if (handleOnChange) {
                  handleOnChange(event);
                }
                if (thousandSeparator) {
                  const raw = event.target.value.replace(/,/g, '');
                  const dotIdx = raw.indexOf('.');
                  let formatted: string;
                  if (dotIdx === -1) {
                    const num = parseFloat(raw);
                    formatted = raw === '' || isNaN(num) ? raw : num.toLocaleString('en-US');
                  } else {
                    const intPart = raw.substring(0, dotIdx);
                    const decPart = raw.substring(dotIdx);
                    const num = parseFloat(intPart);
                    const fmtInt =
                      intPart === '' || isNaN(num) ? intPart : num.toLocaleString('en-US');
                    formatted = fmtInt + decPart;
                  }
                  onChange({
                    ...event,
                    target: { ...event.target, value: formatted },
                  });
                } else {
                  onChange(event);
                }
              }}
              value={
                thousandSeparator && value != null && value !== ''
                  ? (() => {
                      const str = String(value).replace(/,/g, '');
                      const dotIdx = str.indexOf('.');
                      if (dotIdx === -1) {
                        const num = parseFloat(str);
                        return isNaN(num) ? str : num.toLocaleString('en-US');
                      }
                      const intPart = str.substring(0, dotIdx);
                      const decPart = str.substring(dotIdx);
                      const num = parseFloat(intPart);
                      const fmtInt =
                        intPart === '' || isNaN(num) ? intPart : num.toLocaleString('en-US');
                      return fmtInt + decPart;
                    })()
                  : value
              }
              invalid={!!fieldError}
              data-testid={name}
              {...inputProps}
              type={inputType}
            />
          </div>
        )}
      />
      {errorMessage && <ErrorMessage>{errorMessage as string}</ErrorMessage>}
    </>
  );
};
export default FormControlTextInput;
